import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    tracking_links: [],
    selectedTemplate: null,
    total:{
      perCbm : 0,
      all : 0,
    },
    loaded : false,
    addNew : false,
})

  // getters
  const getters = {
    destinationBlocks : (state) => (status) => {
        return state.list.filter(item => item.data.destination == status)
    },
    transport_costs_for_skonto: (state) => () => {
        let tmp = 0;
        if(state.list && state.list[0] && state.list[0].blocks && state.list[0].blocks[0] && state.list[0].blocks[0].version == 2){
            for(let i in state.list){
               for(let j in state.list[i].blocks ){
                   if(!state.list[i].blocks[j].invoice_amount){
                       tmp += state.list[i].blocks[j].pre_calculated_amount;
                    }else{
                        let utilize = 0;
                        if(state.list[i].blocks[j].data?.invoiceAmountBrutto){
                            utilize = state.list[i].blocks[j].data?.invoiceAmountBrutto;
                        }else{
                            utilize = state.list[i].blocks[j].invoice_amount;
                        }
                        tmp += (utilize * state.list[i].blocks[j].exchange_rate_to_selling);
                    }
                }
            }
        }else{
            for(let i in state.list){
                if(!state.list[i].invoice_amount){
                    tmp += state.list[i].pre_calculated_amount;
                }else{
                    let utilize = 0;
                    if(state.list[i].data?.invoiceAmountBrutto){
                            utilize = state.list[i].data?.invoiceAmountBrutto
                        }else{
                            utilize = state.list[i].invoice_amount;
                        }
                    tmp += (utilize * state.list[i].exchange_rate_to_selling);
                }
            }
        }
        return tmp;
    },
    find_date_field: (state) => (findType) => {
        for(let group in state.list){
            if(state.list[group]?.blocks){
                for(let i in state.list[group].blocks){
                    if(state.list[group]?.blocks[i]?.data){
                        for(let date in state.list[group].blocks[i].data.dates){
                            if(state.list[group].blocks[i].data.dates[date].type == findType){
                                return state.list[group].blocks[i].data.dates[date].value
                            }
                        }
                    }
                    }
                }
        }

    }
  }

  // actions
  const actions = {
    async reload({commit, rootState}, data){
        return axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/kooi_data/" + data.kooi_id + "/logistics").then((response) => {
            commit("init", response.data.data)
        })
    },
    async destroy({commit, state, rootState}, data){
      axios.delete(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/kooi/" + data.kooi_id + "/logistic/" + data.item.id).then((response) => {
        commit("removeBlock", state.list.findIndex(item => item.id == data.item.id));
      }).catch((error) => {
        console.log(error.response.status);
      });
    }
  }

  // mutations
  const mutations = {
    setTemplate(state, data){
        state.selectedTemplate = data;
    },
      clearBlocks(state){
          state.list = [];
      },
      addBlock(state, blocks){
          state.list.push(...blocks);
      },
      removeBlock(state, index){
        state.list.splice(index, 1);
        },
      setBlock(state, data){
          if(state.list[data.index] != undefined){
            state.list[data.index].data = data.data;
          }
      },
      setBlockWithId(state, data){
        var index = state.list.findIndex(item => item.data.id == data.id);
        if(index > 0){
          state.list[index].data = data.data;
        }
      },
      init(state, data){
          state.list = data;
      },
      tracking(state, links){
        state.tracking_links = links;
      },
      destroyTracking(state, id){
        let index = state.tracking_links.findIndex(item => item.id == id);
        if(index >= 0){
            state.tracking_links.splice(index, 1);
        }
      },
      updateTracking(state, kooiSlug){
        let index = state.tracking_links.findIndex(item => item.id == kooiSlug.id);
        if(index >= 0){
            state.tracking_links[index] = kooiSlug;
        }else{
            state.tracking_links.push(kooiSlug);
        }
      },
      setTotalPerCbm(state, total)
      {
        state.total.perCbm = total;
      },
      setTotal(state, total)
      {
        state.total.all = total;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
